<template>
<!-- eslint-disable vue/valid-v-slot -->
  <v-dialog max-width="640px" :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="show"
    v-on:click:outside="SaveWagon"
    >
    <v-card class="rounded-card">
        <v-system-bar color="primary" height="60px">
          <v-img contain max-width="36px" src="../assets/self_light.png" class="mx-2" />
          <span class="headline font-weight-bold ms-2">
            {{wagon.id ? $t('Edit Wagon') + wagon.name  + " [" + wagon.tmr.code +"]": $t('New Wagon')}}
          </span>
        </v-system-bar>
        <v-card-text class="pb-1">
          <v-layout wrap>
            <v-flex xs5 sm7>
              <v-text-field :label="$t('Wagon Name')" v-model="wagon.name"></v-text-field>
            </v-flex>
            <v-flex xs2 sm1 ></v-flex>
            <v-flex xs5 sm4>
              <v-text-field :label="$t('Order')" v-bind:value="wagon.order" v-on:change="onOrderChanged"  type="number" min="0"></v-text-field>
            </v-flex>
          </v-layout>
          <!-- <v-layout wrap>
              <v-flex xs12 sm7>
                <v-select flat :items="dropdown_tmrs"
                  v-model="wagon.tmr"
                  :label="TMR" editable
                  :hint="The TMR to make in this wagon"
                  >
                </v-select>
              </v-flex>
              <v-flex v-if="$vuetify.breakpoint.smAndUp" sm1 ></v-flex>
              <v-flex xs12 sm4>
              <v-text-field :label="Last_Modified" v-model="modifiedDate" disabled></v-text-field>
            </v-flex>
          </v-layout> -->
          <v-layout wrap>
              <WeekdayPicker
                class="v-inline-flex"
                v-bind:currentSelection.sync="wagon.onlyForDays" inDialog
              ></WeekdayPicker>
          </v-layout>
        </v-card-text>
        <!-- Groups table -->
          <v-data-table
          :headers="headers"
          :items="indexedGroups"
          item-key="id"
          disable-pagination
          fixed-header
          disable-sort
          hide-default-footer
          :no-data-text="$t('Drag Groups to this wagon rectangle')"
          class="ms-4 ps-2"
          >
          <template v-slot:item.action="{ item }">
            <v-icon small color="primary lighten-2" class="ms-3" @click="removeGroup(item)">mdi-delete</v-icon>
          </template>
          <!-- <template v-slot:item.index="{ item }">
            {{wagon.groups.indexOf(item)+1}}
          </template> -->
          <template v-slot:item.doses="{ item }">
            {{getDoses(item.qty)}}
          </template>
          <template v-slot:item.dailyPercent="{ item }">
            {{item.dailyPercent | percentValue}}
          </template>
        </v-data-table>
        <p class="primary--text subtitle-2 mt-1 mb-0 ms-3 ps-2">{{$t('Daily delivery schedule')}}:</p>
        <v-simple-table fixed-header dense class="mx-3 mb-2">
          <thead>
            <tr>
              <th class="text-center primary--text" v-for="(day, index) in weekdays" v-bind:key="index" >{{day}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="text-center" v-for="(value, index) in weekdayQty" v-bind:key="index">{{value | kgString}}</th>
            </tr>
          </tbody>

        </v-simple-table>

        <!--             -->
        <v-card-actions>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="DeleteWagon">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Remove This Wagon')}}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <span class="mx-12 pt-1 subhead primary--text text--lighten-1">{{$t('Daily Maximum')}}: {{totalQty | kgString}}</span>
          <!-- <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon color="primary" v-on="on" @click.stop="CancelDialog">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>Cancel (exit without saving)</span>
          </v-tooltip> -->
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="SaveWagon">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Close Dialog')}}</span>
          </v-tooltip>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import  WeekdayPicker from "../components/WeekdayPicker";

export default {
  name: "AddEditWagon",
  components: {
      WeekdayPicker
  },
  props: {
        value: Boolean,
        wagonId: String
    },
  data() {
    return {
      headers: [
        { text: "#", width: "8%", align: "left", value: "id", class: "primary--text" },
        { text: this.$i18n.t('Group'), width: "10%", align: "left", value: "code", class: "primary--text" },
        { text: this.$i18n.t('Name'), width: "22%", value: "name", class: "primary--text" },
        { text: this.$i18n.t('Qty_Kg'), align: "right", value: "qty", class: "primary--text" },
        { text: this.$i18n.t('Doses'), align: "right", value: "doses", class: "primary--text" },
        { text: this.$i18n.t('Daily_'), align: "right", value: "dailyPercent", class: "primary--text" },
        { text: " ", width: "10%", value: "action", sortable: false },
      ],
      weekdays: [this.$i18n.t('Sun'), this.$i18n.t('Mon'), this.$i18n.t('Tue'), this.$i18n.t('Wed'), this.$i18n.t('Thu'), this.$i18n.t('Fri'), this.$i18n.t('Sat') ],
    };
  },
  watch: {

  },
  created: function() {

  },
  computed: {
    wagon() {
      return this.$store.getters.getWagon(this.wagonId);
    },
    indexedGroups() {
      return this.wagon.groups.map((item, index) => ({
        id: index+1,
        ...item
      }))
    },
    dropdown_tmrs() {
      return  this.$store.getters.getTMRs
      .filter(function(x) {
        return (x.premixkey == undefined || x.premixkey == null || x.premixkey == "") && (! x.inactive) == true
      })
      .map(function(x) {
        return {
            text: x.code + " - " + x.name + "   [" +
                 Math.round(x.doseweight * 1000) / 1000 + " " + this.$i18n.t('Kg') +"]",
            value: { code: x.code, documentID: x.Id }
        }
      });
    },
    totalQty() {
      // return this.wagon.groups.reduce((a, g) => isNaN(Number(g.qty)) ? a : a + Number(g.qty), 0);
      //return the max from weekday qty.:
      return this.weekdayQty.reduce( (a, g) => a>g ? a : g);
    },
    weekdayQty() {
      return this.$store.getters.weekdayQty(this.wagon);
    },
    modifiedDate() {
      if (this.wagon.lastModified && typeof this.wagon.lastModified.getMonth === "function")
        return this.wagon.lastModified.toLocaleDateString();
      else
        return (new Date("01/01/2000")).toLocaleDateString();
    },
    show: {
        get () {
            return this.value
        },
        set (value) {
            this.$emit("input", value);
            this.value = value;
        }
    },
  },
  methods: {
    getDoses(qty) {
      return this.$store.getters.getDosesFromQty(qty, this.wagon.tmr.documentID)
    },
    removeGroup(grp) {
      this.$store.dispatch("removeGroupFromWagon", {wagonId: this.wagonId, wGroup: grp});
    },
    onOrderChanged(evnt) {
    //console.log(evnt, this.$i18n.t(', ') + this.wagon.order );
      let prev = this.wagon.order;
      //this.wagon.order = evnt;
      this.$store.dispatch("changeWagonOrder", {wagon: this.wagon, prevOrder: prev, newOrder: Number(evnt)});
    },
    SaveWagon() {
      this.$store.dispatch("saveWagon", this.wagon);
      this.$emit("close");
    },
    DeleteWagon() {
        this.$root.$confirm(this.$i18n.t('Delete'), this.$i18n.t('Remove wagon') + " " + this.wagon.name + "?", { color: "red" }).then((confirm) => {
          if (confirm) {
            this.$emit("delete");
          }
        });
      }
    },
}
</script>

<style scoped>
  .v-data-table td, .v-data-table th {
    padding: 0 8px !important;
  }
  .v-data-table table {
    border: 2px;
  }
</style>>

